module.exports = __webpack_public_path__ + "img/04.eclipse-light.1d0394a9.svg";